<div class="bg-image">
  <div class="container h-100">
    <div class="row d-flex align-items-center h-100">
      <div class="col-12">
        <div class="card border-radius-50">
          <mat-horizontal-stepper [linear]="true" labelPosition="bottom" #stepper class="border-radius-50">
            <mat-step [stepControl]="firstForm" [editable]="isEditable">
              <h2 class="text-center mt-3 mb-5 title-stepper">Você já estudou Inglês ? </h2>
              <form [formGroup]="firstForm" (submit)="onSubmittedStudiedEnglish()">
                <div class="radio-buttons">
                  <label class="custom-radio">
                    <input 
                      type="radio"
                      value="N" 
                      formControlName="studiedEnglish"
                    >
                    <span class="radio-btn">
                      <i class="fas fa-check"></i>
                      <div class="hobbies-icon">                      
                        <i class="fas fa-book-reader"></i>
                        <h3><span>Não</span>,<br> sou iniciante!</h3>
                      </div>
                    </span>
                  </label>
                  <label class="custom-radio">
                    <input 
                      type="radio"
                      value="S" 
                      formControlName="studiedEnglish"
                    >
                    <span class="radio-btn">
                      <i class="fas fa-check"></i>
                      <div class="hobbies-icon">                      
                        <i class="fas fa-user-graduate"></i>
                        <h3><span>Sim</span>,<br> quero fazer nivelamento!</h3>
                      </div>
                    </span>
                  </label>
                </div>
                <div class="float-right">
                  <button 
                    type="submit"
                    class="btn-lg" 
                    mat-flat-button color="primary" 
                    matStepperNext
                    [disabled]="!firstForm.valid"
                  >
                    Avançar <i class="fas fa-angle-double-right"></i>
                  </button>
                </div>              
              </form>
            </mat-step>
            <mat-step [stepControl]="levelingForm" [editable]="isEditable">
              <h4 class="text-center mt-3 mb-5">O nivelamento icbeu é realizado de forma online. Para isso, precisaremos que você nos dê algumas informações:</h4>

              <form [formGroup]="levelingForm" (submit)="onSubmittedScheduler()"  novalidate autocomplete="off">                
                <div class="form-row">
                  <div class="col-md-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Em qual instituição você estudou ?</mat-label>
                      <input 
                        matInput 
                        placeholder="Ex: Icbeu Manaus"
                        formControlName="studiedWhere"
                      >
                      <mat-icon matSuffix>school</mat-icon>                      
                    </mat-form-field>
                  </div>    
                  
                </div><!-- .form-row -->
                <div class="form-row">
                  <div class="col-md-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Por quanto tempo ?</mat-label>
                      <input 
                        matInput 
                        placeholder="Ex: 1 ano e 6 meses, 2 anos, 2,5 anos, etc"
                        formControlName="studiedTime"
                      >
                      <mat-icon matSuffix>hourglass_empty</mat-icon>                      
                    </mat-form-field>
                  </div>    
                  
                </div><!-- .form-row -->

                <div class="form-row">
                  <div class="col-md-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Está há quanto tempo sem estudar ?</mat-label>
                      <input 
                        matInput 
                        placeholder="Ex: Estou praticando, 2 anos, fiz intercâmbio, etc."
                        formControlName="timeWithoutStudying"
                      >
                      <mat-icon matSuffix>restore</mat-icon>                      
                    </mat-form-field>
                  </div>    
                  
                </div><!-- .form-row -->

                <div class="form-row">
                  <div class="col-md-12">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Em que modalidade deseja estudar conosco ?</mat-label>
                      <mat-select formControlName="modalityId">
                        <mat-option value="1">Aula Presencial</mat-option>
                        <mat-option value="2">Aula Remota</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div><!-- .form-row -->
                                    
                <h6 class="mt-2 mb-3">Escolha um horário para seu agendamento</h6>

                <div class="form row">                    
                  <div class="col-12 col-md-4">                    
                    <bs-datepicker-inline 
                      [bsValue]="bsInlineValue"
                      (bsValueChange)="onValueChange($event)"
                    ></bs-datepicker-inline>                        
                  </div>
                  <div class="col-12 col-md-8">                      
                    <div *ngIf="!submittingHour" class="w-100 my-3">
                      <mat-chip-list class="mat-chip-list-stacked" aria-label="Color selection" *ngIf="hours.length > 0, else noDataHours">                        
                        <mat-chip 
                          class="p-3" 
                          *ngFor="let h of hours" 
                          [color]="h.color"
                          selected="{{ h.vacancy === 'S' ? true : false }}"
                          [style.box-shadow]="seletectedHourId === h.id ? '0 0 12px green' : null" 
                          (click)="onValueHourId(h)"
                        >
                          <div class="row d-flex flex-column" [ngClass]="{'cursor-pointer': h.vacancy === 'S'}">
                            <span>Horário: {{ h.descricao }}</span>
                            <span *ngIf="h.vacancy === 'S'">{{ h.txtVacancy }}: {{ h.inscritos }}/{{ h.qtde }}</span>
                            <span *ngIf="h.vacancy === 'N'">{{ h.txtVacancy }}</span>
                          </div>
                          
                        </mat-chip>
                      </mat-chip-list>   
                      <ng-template #noDataHours>
                        <div class="d-flex justify-content-center align-items-center h-100">
                          <div class="alert alert-info">
                            <h4 class="text-center"><i class="fas fa-exclamation-triangle"></i> Não há horários para este dia</h4>
                          </div>
                        </div>
                        
                      </ng-template>
                    </div>
                    
                    <div *ngIf="submittingHour" class="mt-3">
                      <div class="d-flex justify-content-center">
                        <div class="spinner-border text-success" role="status" style="width: 3rem; height: 3rem;">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row" *ngIf="messagesErrors.length > 0">
                  <div class="alert alert-danger mt-3 w-100" role="alert">
                    <h4 class="font-weight-bold">Erros encontrados: </h4>
                    <ul class="my-2 px-4" *ngFor="let msg of messagesErrors">
                      <li> {{ msg.msg }}</li>
                    </ul>
                  </div>
                </div>
                
                <div class="float-right">
                  <button 
                    mat-button 
                    mat-flat-button color="primary"
                    matStepperPrevious
                  >
                    <i class="fas fa-angle-double-left"></i> Voltar
                  </button>
                  <button      
                    class="btn-lg"               
                    mat-button 
                    mat-flat-button color="primary"
                    matStepperNext
                    [disabled]="!levelingForm.valid"                      
                  >
                    <i class="fas fa-calendar-plus"></i> Agendar
                  </button>
                </div>
              </form>
            </mat-step>
            <mat-step>
              <div *ngIf="submittingScheduler" class="w-100">
                <div class="text-center">
                  <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Carregando...</span>
                  </div>
                </div>
              </div>
              <div *ngIf="!submittingScheduler && isSchedulerOk">
                <div class="row text-center">
                  <div class="col-12">
                    <img src="assets/img/icons/svg/confirmation_2uy0.svg"  width="300" class="my-3">
                    <h3 class="">{{ returnMessage }} </h3>
                    <p class="lead">Em breve, Será enviado para você via SMS/EMAIL o link para realização do nivelamento online.</p>
                    <a
                      mat-stroked-button        
                      color="primary"
                      class="btn-lg py-1"         
                      type="button"
                      tabindex="0"
                      (click)="redirect()"
                    >
                      <i class="fas fa-user-shield"></i> Completar meu cadastro
                    </a>
                  </div>
                </div>                                
              </div>

              <div *ngIf="!submittingScheduler && !isSchedulerOk">
                <div class="row text-center">
                  <div class="col-12">
                    <img src="assets/img/icons/svg/warning_draw.svg"  width="300" class="my-3">
                    <h3 class="">{{ returnMessage }} </h3>
                    <p class="lead">Não se preocupe, é só tentar novamente clicando em <b>VOLTAR</b>.</p>
                    <button 
                      mat-button 
                      mat-flat-button color="primary"
                      matStepperPrevious
                      (click)="onValueChange()"
                    >
                      <i class="fas fa-angle-double-left"></i> Voltar
                    </button>                   
                  </div>
                </div>
              </div>
            </mat-step>
          </mat-horizontal-stepper>
        </div>        
      </div>
    </div>
  </div>
</div>